import "core-js/modules/es.array.push.js";
import request from "../../util/request";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Template',
  data() {
    let validateSolution_Name = (rule, value, callback) => {
      if (value === this.repeatName && this.dialogFormVisibleEdit === true) {
        callback();
      } else {
        request.get('/Template/getByName', {
          params: {
            templateName: value
          }
        }).then(res => {
          console.log(res);
          if (res == null || res == '') {
            callback();
          } else {
            callback(new Error("名称重复，重新输入！"));
          }
        });
      }
    };
    return {
      search: '',
      parentId: -1,
      //省份的上层节点
      areaList: [],
      areaParentIdOne: '',
      repeatName: '',
      //判断名称是否重复
      // select:null,
      form: {},
      //即将提交到数据库的保存数组
      options: [],
      //评分方案的类型列表
      option: {},
      //评分方案的类型对象
      editform: {},
      //要提交到数据库的修改数组
      temporarilyform: {},
      //缓存数组
      dialogFormVisibleEdit: false,
      dialogFormVisible: false,
      currentPage: 1,
      pageSize: 20,
      total: 10,
      small: "small",
      background: "background",
      prev: this.currentPage - 1,
      pager: this.currentPage,
      next: this.currentPage + 1,
      jumper: this.currentPage,
      ticket: [],
      //未分页的数据
      tableData: [],
      //渲染到页面上的数据
      reload: 0,
      //判断重新将currentPage 设置为 1； 0：currentPage=1
      varValue: "",
      //判断是否已经点击了模糊查询
      rules: {
        templateName: [
        // { pattern:/^([a-z0-9]([a-z0-9-.]*)[a-z0-9])$|^([a-z0-9])$/, message: '只能输入小写字母、数字、点号.和横线-并且点号 . 和横线 - 不能在开头或结尾', trigger: 'blur' },
        {
          required: true,
          min: 2,
          max: 50,
          message: '模板名不能为空,长度： 2 ~ 50',
          trigger: 'blur'
        }, {
          validator: validateSolution_Name,
          required: true,
          message: '方案名重复，重新输入',
          trigger: 'blur'
        }]
        // areaParentIdOne: [
        //  {required: true,  message: '所属省份不为空', trigger: 'blur'},
        // ],
      }
    };
  },

  created() {
    //sessionStorage临时保存
    console.log(sessionStorage.getItem('userName'));
    this.load();
  },
  methods: {
    //通过名称查询
    qSearch() {
      if (this.search == null || this.search == "") {
        console.log("为空就查全部");
        this.load();
      }
      request.get('/Template/getByName', {
        params: {
          templateName: this.search
        }
      }).then(res => {
        console.log(res);
        this.tableData = res;
        this.total = this.tableData.length;
      });
    },
    //添加按钮点击事件
    add() {
      this.dialogFormVisible = true;
      this.queryAreaList(this.parentId);
    },
    queryAreaList(parentId) {
      request.post('/Device/selectArea', parentId).then(res => {
        console.log(res.data);
        this.areaList = res.data;
      });
    },
    //时间格式
    formatDate(value, fmt) {
      if (value == null || value == '') {
        return "";
      }
      let getDate = new Date(value);
      let o = {
        'M+': getDate.getMonth() + 1,
        'd+': getDate.getDate(),
        'h+': getDate.getHours(),
        'm+': getDate.getMinutes(),
        's+': getDate.getSeconds(),
        'q+': Math.floor((getDate.getMonth() + 3) / 3),
        'S': getDate.getMilliseconds()
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return fmt;
    },
    //页面初始化
    load() {
      request.get('/Template/templateAll').then(res => {
        console.log(res);
        this.ticket = res;
        this.total = this.ticket.length;
        this.getPageInfo();
      });
    },
    //取消
    submitCacel() {
      this.dialogFormVisibleEdit = false;
      this.areaParentIdOne = '';
    },
    //保持数据
    save(formName) {
      if (this.form.templateName == '' || this.form.templateName == null) {
        this.$alert('请输入检测模板名称', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            console.log(action);
          }
        });
        return;
      }
      console.log(this.areaParentIdOne + "----this.areaParentIdOne");
      if (this.areaParentIdOne.length == 0) {
        this.$alert('请选择所属省份', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            console.log(action);
          }
        });
        return;
      }
      console.log(this.$refs[formName]);
      this.$refs[formName].validate(valid => {
        //valid是检验的结果,bool值 validator: validateSolution_Name,

        if (valid) {
          this.form.createBy = sessionStorage.getItem('userName');
          this.form.createDate = new Date();
          // this.form.templateNo = "123456789"
          this.form.areaId = this.areaList[this.areaParentIdOne].areaId;
          this.form.areaName = this.areaList[this.areaParentIdOne].areaName;
          request.post('/Template/save', this.form).then(res => {
            console.log(res.code + res.mag + res.date + "save" + res);
            if (res == 1) {
              this.$message({
                message: "添加成功",
                type: "success"
              });
              this.load();
              this.dialogFormVisible = false;
              this.form = {};
              this.areaParentIdOne = '';
            } else {
              this.$message({
                message: "添加失败",
                type: "error"
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //修改数据
    edit(formName) {
      if (this.editform.templateName == '' || this.editform.templateName == null) {
        this.$alert('请输入检测模板名称', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            console.log(action);
          }
        });
        return;
      }
      if (this.areaParentIdOne.length == 0) {
        this.$alert('请选择所属省份', '提示', {
          confirmButtonText: '确定',
          callback: action => {
            console.log(action);
          }
        });
        return;
      }
      console.log(this.$refs[formName]);
      //console.log(this.editform.solution_Lock+"--"+this.editform.solution_StatType+"--"+this.editform.solution_Type)
      this.$refs[formName].validate(valid => {
        //valid是检验的结果,bool值
        if (valid) {
          this.editform.updateBy = sessionStorage.getItem('userName');
          this.editform.updateDate = new Date();
          this.editform.templateName = this.editform.templateName.replace(/\s*/g, '');
          this.editform.areaId = this.areaList[this.areaParentIdOne].areaId;
          this.editform.areaName = this.areaList[this.areaParentIdOne].areaName;
          request.post('/Template/update', this.editform).then(res => {
            if (res == 1) {
              this.$message({
                message: "编辑成功",
                type: "success"
              });
              this.load();
              this.areaParentIdOne = '';
              this.dialogFormVisibleEdit = false;
            } else {
              this.$message({
                message: "编辑失败",
                type: "error"
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //跳转到模板大项页面
    toMaxterm(templateId) {
      this.$router.push({
        path: 'Maxterm',
        query: {
          templateId: templateId
        }
      });
    },
    //修改按钮点击事件
    update(row) {
      this.dialogFormVisibleEdit = true;
      console.log(row);
      this.editform = JSON.parse(JSON.stringify(row));
      this.areaParentIdOne = '';
      console.log(this.editform);
      this.queryAreaList(this.parentId);
      this.repeatName = JSON.parse(JSON.stringify(row.templateName));
      for (let i = 0; i < this.areaList.length; i++) {
        if (this.areaList[i].areaId === this.editform.areaId) {
          this.areaParentIdOne = i;
        }
      }
    },
    //修改按钮点击事件
    deleteOne(templateId) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.post('/Template/delete', templateId).then(res => {
          if (res > 0) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          }
          if (res == -1) {
            this.$alert('该检测模板下还有内容', '提示', {
              confirmButtonText: '确定'
            });
          }
          if (res == -2) {
            this.$message({
              type: 'info',
              message: '删除失败'
            });
          }
          this.load();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //分页三件套
    // 获取当前页的数据信息
    getPageInfo() {
      //清空pageTicket中的数据
      this.tableData = [];
      // 获取当前页的数据
      for (let i = (this.currentPage - 1) * this.pageSize; i < this.total; i++) {
        //把遍历的数据添加到pageTicket里面
        this.tableData.push(this.ticket[i]);
        //判断是否达到一页的要求
        if (this.tableData.length === this.pageSize) break;
      }
    },
    handleSizeChange(pageSize) {
      //修改当前每页的数据行数
      this.pageSize = pageSize;
      //数据重新分页
      this.getPageInfo();
    },
    handleCurrentChange(pageNum) {
      //修改当前的页码
      this.currentPage = pageNum;
      //数据重新分页
      this.getPageInfo();
    },
    tableRowClassName({
      rowIndex
    }) {
      for (var i = 0; i < this.tableData.length; i++) {
        if (rowIndex === i) {
          return 'success-row';
        }
        /*if (this.tableData[i].solution_Lock === "锁定") {
          if (rowIndex === i) {
            return 'warning-row';
          }
        } else {
          if (rowIndex === i) {
            return 'success-row';
          }
        }*/
      }

      return '';
    }
  }
};